import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "../../wepcg/sidebar/help_hints";
import "../../wepcg/sidebar/css/wepcg_bar.css"

class CBSOMaintenanceContractsBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>CBSO Maintenance Contracts</strong></h1>
            <p>
                This claim type is used if the maintenance invoice is not correct. Please attach as much information and background as possible. In case Purchase Order (PO) reference on invoice is not correct, please attach correct PO. In case incorrect invoice recipient / address, incorrect coverage period invoiced or other incorrect data, please attach correct details. Contact our financial claims team in case there is any question or problem.
            </p>
            <Help_hints />
        </div>
    }
}

export default CBSOMaintenanceContractsBar;